import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage } from 'core/yup';
import { QuoteEntityType } from 'quotes/enums';

export const upsertVendorQuoteSchema = (entityType = QuoteEntityType.QUOTE) => {
  const baseSchema = yup.object().shape({
    project: yup
      .object()
      .label(t('labelProject'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelProject'))),
    jobName: yup
      .string()
      .label(t('labelJobName'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelJobName'))),
    contact: yup
      .object()
      .label(t(`labelVendor${entityType}Contact`))
      .nullable()
      .required(getEmptyErrorMessage(t(`labelVendor${entityType}Contact`))),
    externalProjectName: yup.string().label(t('labelVendorProjectName')).nullable(),
    externalNumber: yup.string().label(t('labelVendorQuoteNumber')).nullable(),
    revisionNumber: yup.string().label(t('labelVendorQuoteRevision')).nullable(),
  });

  if (QuoteEntityType.ORDER === entityType) {
    const orderSchema = yup.object().shape({
      purchaseOrderNumber: yup.string().label(t('labelPurchaseOrderNumber')).nullable(),
      agreeTermsAndConditions: yup.boolean().label(t('labelAgreeTermsAndConditions')).nullable(),
    });

    return baseSchema.concat(orderSchema);
  }

  return baseSchema;
};
